/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_Ai_Format_AutoInputs */

const cs_templates_ai_format_auto = /** @type {(inputs: Templates_Ai_Format_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automaticky`)
};

const en_templates_ai_format_auto = /** @type {(inputs: Templates_Ai_Format_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auto-detect`)
};

/**
* | output |
* | --- |
* | "Auto-detect" |
*
* @param {Templates_Ai_Format_AutoInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const templates_ai_format_auto = /** @type {((inputs?: Templates_Ai_Format_AutoInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_Ai_Format_AutoInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_ai_format_auto(inputs)
	return cs_templates_ai_format_auto(inputs)
});